export const GET_LIST_ADDRESS = "GET_LIST_ADDRESS"
export const GET_LIST_ADDRESS_SUCCESS = "GET_LIST_ADDRESS_SUCCESS"
export const GET_LIST_ADDRESS_FAIL = "GET_LIST_ADDRESS_FAIL"